// src/pages/DailySpending.js
import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import moment from "moment";

function Row({ item, onChange, onRemove }) {
  return (
    <tr>
      <td><input value={item.name} onChange={(e)=>onChange({ ...item, name: e.target.value })} /></td>
      <td><input type="number" value={item.amount} onChange={(e)=>onChange({ ...item, amount: e.target.value })} /></td>
      <td><button className="red-button" onClick={onRemove}>Remove</button></td>
    </tr>
  );
}

export default function DailySpending(){
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [creditCards, setCreditCards] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  useEffect(() => {
    (async () => {
      const snap = await getDoc(doc(db, "dailySpending", date));
      if (snap.exists()){
        const d = snap.data();
        setCreditCards(d.creditCards || []);
        setBankAccounts(d.bankAccounts || []);
      } else {
        setCreditCards([]);
        setBankAccounts([]);
      }
    })();
  }, [date]);

  const save = async () => {
    await setDoc(doc(db, "dailySpending", date), { date, creditCards, bankAccounts });
    alert("Saved!");
  };

  const addCC = () => setCreditCards([...creditCards, { name: "", amount: 0 }]);
  const addBank = () => setBankAccounts([...bankAccounts, { name: "", amount: 0 }]);

  const totalCC = creditCards.reduce((s,c)=>s+Number(c.amount||0),0);
  const totalBank = bankAccounts.reduce((s,b)=>s+Number(b.amount||0),0);

  return (
    <div style={{ padding:16 }}>
      <h2>Daily Spending — {date}</h2>
      <input type="date" value={date} onChange={(e)=>setDate(e.target.value)} />

      <h3 style={{ marginTop: 16 }}>Credit Cards</h3>
      <button className="yellow-button" onClick={addCC}>Add Card Charge</button>
      <div className="table-container" style={{ overflowX: "auto", marginTop: 8 }}>
        <table>
          <thead><tr><th>Name</th><th>Amount</th><th>Action</th></tr></thead>
          <tbody>
            {creditCards.map((x, i)=>(
              <Row key={`cc-${i}`}
                item={x}
                onChange={(newX)=>{ const copy=[...creditCards]; copy[i]=newX; setCreditCards(copy); }}
                onRemove={()=>{ const copy=[...creditCards]; copy.splice(i,1); setCreditCards(copy); }}
              />
            ))}
            {creditCards.length===0 && <tr><td colSpan={3} style={{textAlign:"center"}}>No card entries.</td></tr>}
          </tbody>
        </table>
      </div>
      <div><strong>Total Cards: ${totalCC.toFixed(2)}</strong></div>

      <h3 style={{ marginTop: 16 }}>Bank Accounts</h3>
      <button className="yellow-button" onClick={addBank}>Add Bank Spend</button>
      <div className="table-container" style={{ overflowX: "auto", marginTop: 8 }}>
        <table>
          <thead><tr><th>Name</th><th>Amount</th><th>Action</th></tr></thead>
          <tbody>
            {bankAccounts.map((x, i)=>(
              <Row key={`bk-${i}`}
                item={x}
                onChange={(newX)=>{ const copy=[...bankAccounts]; copy[i]=newX; setBankAccounts(copy); }}
                onRemove={()=>{ const copy=[...bankAccounts]; copy.splice(i,1); setBankAccounts(copy); }}
              />
            ))}
            {bankAccounts.length===0 && <tr><td colSpan={3} style={{textAlign:"center"}}>No bank entries.</td></tr>}
          </tbody>
        </table>
      </div>
      <div><strong>Total Banks: ${totalBank.toFixed(2)}</strong></div>

      <div style={{ marginTop: 12 }}>
        <button className="green-button" onClick={save}>Save</button>
      </div>
    </div>
  );
}
